import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  headerContainer: {
    paddingBottom: '310px',
    backgroundImage: `url(https://d222i9ppxs2fqe.cloudfront.net/mobileHero_opt.jpg)`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    [theme.breakpoints.up('md')]: {
      paddingBottom: '370px',
      backgroundImage: `url(https://d222i9ppxs2fqe.cloudfront.net/hero_our_story.jpg)`,
    },
  },

  titleDescriptionContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },

  title: {
    flex: 1,
    backgroundColor: theme.palette.cinnamon.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundOrigin: 'content-box',
    padding: '50px 35px',

    [theme.breakpoints.up('sm')]: {
      padding: '50px',
    },

    [theme.breakpoints.up('lg')]: {
      padding: '95px 75px',
    },
  },

  description: {
    flex: 1,
    backgroundColor: theme.palette.turmeric.main,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '35px',
    [theme.breakpoints.up('sm')]: {
      padding: '50px',
    },
    [theme.breakpoints.up('lg')]: {
      padding: '85px 75px',
    },
  },

  planBannerWrapper: {
    position: 'sticky',
    bottom: '0px',
    boxShadow: '0px -10px 20px rgba(0, 0, 0, 0.25)',
    zIndex: 11,
  },

  joinUs: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: `url(https://d222i9ppxs2fqe.cloudfront.net/aboutUsMaskGroupMobile_opt.jpg)`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    padding: '215px 0',
    [theme.breakpoints.up('md')]: {
      padding: '200px 0 85px',
      backgroundImage: `url(https://d222i9ppxs2fqe.cloudfront.net/aboutUsMaskGroup_opt.jpg)`,
    },
    [theme.breakpoints.up('lg')]: {
      padding: '200px 0 185px',
    },
    [theme.breakpoints.up('lg')]: {
      padding: '270px 0 185px',
    },
  },

  joinUsTitle: {
    [theme.breakpoints.down('sm')]: {
      maxWidth: '175px',
    },
  },

  startSubscriptionBtnWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '20px 0',
    flex: 1,
    '& button': {
      '&:hover': {
        backgroundColor: theme.palette.cinnamon.main,
      },
    },
    [theme.breakpoints.down('sm')]: {
      position: 'absolute',
      bottom: '0',
      width: '100%',
      margin: '0',
    },
  },

  startSubscriptionBtn: {
    width: '425px !important',
    height: '76px !important',
    borderRadius: '55px !important',

    [theme.breakpoints.down('sm')]: {
      width: '100% !important',
      height: '76px !important',
      borderRadius: '0px !important',
    },
  },
});
